import { createFileRoute } from '@tanstack/react-router';
import { ReconciliationPage } from '../../features/settlement';

export const Route = createFileRoute('/portal/settlement/reconciliation')({ component: ReconciliationPage });
